'use strict';

import {participantModel} from "../../models/participantmodel.js";
import {riskModel} from "../../models/riskmodel.js";
import {wpModel} from "../../models/wpmodel.js";
import {continousRiskModel} from "../../models/continousriskmodel.js";
import {riskStateOfPlayModel} from "../../models/riskstateofplaymodel.js";

export class ProjectReportsRiskCtrl
{
	$scope;
	$filter;
	$http;
	$mdDialog;
	jsDataService;
	item = {};
	fieldCfg = {};
	workpackages = [];
	risks = [];
	stateofplay = [];
	stateofplay_instruction = '';

	
	constructor($scope, $http, $filter, $mdDialog, jsDataService){
	
		'ngInject';
		this.$scope = $scope;
		this.$http = $http;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;
		this.classif = this.jsDataService.get('cfgClassif', {});
//		this.workpackages = new projectModel(jsDataService.get('workpackages', {}), $filter, jsDataService);
		this.initWP(jsDataService.get('workpackages', {}));
		this.initRisk(jsDataService.get('risks', {}));
		this.initStateOfPlay(jsDataService.get('stateofplay', {}));
		this.stateofplay_instruction = this.$filter('tr')('project_stateofplay_instruction_tooltip');
	}
	
	initWP(workpackages){
		this.workpackages = [];
		for(let wp of workpackages){
			wp.title = wp.a4_1_work_activities_no;
			wp.id = wp.wp_id;
			this.workpackages.push(new wpModel(wp, this.$filter, this.jsDataService));
		}
		let classif = this.jsDataService.get('cfgClassif');
		classif.wp = this.workpackages;
//		this.jsDataService.set('cfgClassif', classif);
	}
	
	getParticipantField(id, field){
		if(id && typeof(id) === 'object'){
			let fields = [];
			for(let oneId of Object.values(id)){
				let participant = this.getParticipant(oneId);
				if(!participant){
					continue;
				}
				fields.push(participant.getValue(field));
			}
			if(fields.length > 0){
				return fields.join(', ');
			}
			return '';
		}
		else{
			let participant = this.getParticipant(id);
			if(!participant){
				return '';
			}
			return participant.getValue(field);
		}
	}

	initRisk(risks){
		this.risks = [];
		for(let risk of risks){
			risk.wp_title = '';
			if(typeof(risk.wp_ids) === 'object'){
				let titleCollection = [];
				for(let wpid of Object.values(risk.wp_ids)){
					let wpList = this.$filter('filter')(this.workpackages, {id: wpid}, true);
					if(wpList.length > 0){
						titleCollection.push(wpList[0].getValue('wptitle'));
					}
				}
				if(titleCollection.length > 0){
					risk.wp_title = titleCollection.join(', ');
				}
			}			
			this.risks.push(new continousRiskModel(risk, this.$filter, this.jsDataService));
		}
	}
    coerceBool(v){
        return v === true || v === 1 || v === '1' || v === 'true';
    }

    initStateOfPlay(stateplay){
        const prev = {};
        for(let sp of this.stateofplay){
            const id = sp.getValue('contract_reporting_id') || sp.getValue('id') || sp.getValue('no');
            prev[id] = !!sp.disabled;
        }

        this.stateofplay = [];
        for(let sp of stateplay){
            const id = sp.contract_reporting_id || sp.id || sp.no;
            if(typeof sp.disabled !== 'undefined'){
                sp.disabled = this.coerceBool(sp.disabled);
            }else if(typeof prev[id] !== 'undefined'){
                sp.disabled = prev[id];
            }else{
                sp.disabled = false;
            }
            this.stateofplay.push(new riskStateOfPlayModel(sp, this.$filter, this.jsDataService));
        }
    }
	
	getParticipant(id){
		if(typeof(this.workpackage.participants) === 'undefined'){
			return null;
		}
		let prtcps = this.$filter('filter')(this.workpackage.participants, {id: id}, true);
		if(prtcps.length < 1){
			return null;
		}
		return new participantModel(prtcps[0], this.$filter, this.jsDataService);
	}
	
	actionEdit(ev, node){
		if(this.isEdit(node)){
			this.$scope.goUrl(node.edit_url);
		}
	}

	/////
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}

    getDefaultStatePlay(){
        let statePlay = this.jsDataService.get('defaultStateofplay', {});
        let defaultValues = [];
        for(let sp of statePlay){
            defaultValues.push({
                contract_reporting_id: sp.id,
                contract_reporting_no: sp.no,
                materialize: '0',
                apply_mesures: '0',
                comment: '',
                disabled: true
            });
        }
        return defaultValues;
    }
	
	addRisk(ev){
//		const lastRisk = this.risks[this.risks.length-1];
//		const nextNo = lastRisk ? parseInt(lastRisk.no) + 1 : 1;
		const nextNo = (parseInt(this.risks.length) + 1);
		this.riskEditor(ev, new riskModel({
			id: 0,
			ord: this.risks.length,
			no: nextNo,
			type: 1,
			description: '',
			mesures: '',
			probability: '0',
			wp_ids: [],
			stateofplay: this.getDefaultStatePlay()
		}, this.$filter, this.jsDataService));
	}
	
//	editRisk(ev, risk){
//		this.riskEditor(ev, risk);
//	}
	
	riskEditor(ev, risk){
		
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "jsDataService", "risk", this.riskEditorDialogCtrl],
			templateUrl: 'projects/risk_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				risk: risk
			}
		}).then((riskItem) => {
			if(this.jsDataService.get('cfgRiskSaveUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgRiskSaveUrl'),
					method: 'POST',
					data: riskItem
				}).then((response) => {
					if(response.data.success && typeof(response.data.risks) !== 'undefined'){
						this.initRisk(response.data.risks);
						this.initStateOfPlay(response.data.stateofplay);
					}
				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgRiskSaveUrl'));
			}
		}, () => {});
	}
		
	riskEditorDialogCtrl($scope, $mdDialog, $filter, jsDataService, risk){
		$scope.risk = angular.copy(risk);
		let classif = jsDataService.get('cfgClassif');
		$scope.wps = classif.wp;
		$scope.risklevel = classif.risk;
		$scope.yesno = classif.yesno;

		$scope.isValid = function(){
			return true;
		};

		$scope.checkEmpty = function(name){
			if($scope.risk[name] === '0' || $scope.risk[name] === ''){
				$scope.riskForm[name].$setValidity('required', false);
			}
		};
		
		function init(){
			setTimeout(() => {
				if($scope.risk.probability === '0' || $scope.risk.probability === ''){
					$scope.riskForm.probability.$setValidity('required', false);
				}	
			});
		}
		init();
		$scope.close = function() {
			$mdDialog.cancel();
		};
		
		$scope.save = function(){
			$mdDialog.hide($scope.risk.getData());
		}; 
	}
	
	autosavePostFields(){
		let risks = [];
		for(let fkey in this.risks){
			risks.push(this.risks[fkey].getData());
		}
		let stateofplay = [];
		for(let fkey in this.stateofplay){
			stateofplay.push(this.stateofplay[fkey].getData());
		}
		return {
			risks: risks,
			stateofplay: stateofplay
		};
	}

}